import { Component, forwardRef } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../utils/pagination";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../actions/fillCombo_action';
import AdminDrawer from "../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import { getDDReturnList_action } from "../../../actions/admin_module_action/DD_return_action/DD_return_action";
import { exhibitionId, DOC_BASE_URL, serviceTypeId, toastError, contractorListActionId, toastSuccess, HallZoneActionId, HallListActionId, HallZoneListActionId, link_BASE_URL } from "../../../utils/constants";
import Select from 'react-select';
import Modal from "react-modal";
import { data } from "jquery";
// import 'bootstrap-icons/font/bootstrap-icons.css';
import DatePicker from "react-datepicker";
import moment from 'moment';
import { getDamageList_action, getDamageDetails_action } from "../../../actions/admin_module_action/account_exit_pass_action/account_exit_pass_action";


class DDReturnList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            DDreturnListArr: [],
            hallList: [],
            zoneList: [],
            currentPage: 1,
            HallId: '',
            ZoneId: '',
            ExhRegistrationNo: '',
            CompanyName: '',
            vendorName: '',
            DDno: '',
            DDdate: '',
            PTRcount: '',
            Rcount: '',
            mainList: [],
            damageList: [],
            damagetoggle: false,
            damagePop: false,

            exhNo: '',
            exhname: '',
            damageRemark: '',
            damageMarked: '',
            DamageDate: '',
            imgarr: [],
        }
        this.getDDreturnListArr = this.getDDreturnListArr.bind(this)
        this.renderList = this.renderList.bind(this)
        this.updateItem = this.updateItem.bind(this)
        this.clearValue = this.clearValue.bind(this)
        this.handleUpdate = this.handleUpdate.bind(this)
        this.onFilterClick = this.onFilterClick.bind(this)
        this.getDamageList = this.getDamageList.bind(this)
        this.renderDamageList = this.renderDamageList.bind(this)
        this.getDamageDetails = this.getDamageDetails.bind(this)
    }


    componentDidMount() {
        this.getFillList(HallListActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '');
        this.getFillList(HallZoneListActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '');
        this.getDDreturnListArr()
        this.getDamageList()

    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID) {
        const { } = this.state
        return new Promise((resolve, reject) => {

            this.props
                .fill_action(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID)
                .then((data) => {
                    if (data.error != 1) {
                        // voucher list
                        if (actionID === HallListActionId) {
                            this.setState({ hallList: data.data })
                            resolve()

                        }
                        if (actionID === HallZoneListActionId) {
                            this.setState({ zoneList: data.data })
                            resolve()

                        }
                        if (actionID === contractorListActionId) {
                            const array = []
                            data.data.map((item, i) => {
                                array.push(item)
                            })
                            array.push({ ContractorID: 0, CompanyName: 'Other' })
                            this.setState({
                                contractorList: array,
                                //  isLoading: false,
                            }, () => {
                                resolve(array)
                            })
                        }
                    }
                })
        })
    }

    getDDreturnListArr() {
        const { isLoading, DDreturnListArr, hallList, zoneList, currentPage, HallId, ZoneId, ExhRegistrationNo, CompanyName, vendorName, DDno, DDdate } = this.state
        this.setState({ isLoading: true })
        this.props.getDDReturnList_action('', DDno, DDdate != '' && DDdate != null ? moment(DDdate).format("DD MMM YYYY") : '', HallId, ExhRegistrationNo, CompanyName, vendorName, ZoneId)
            .then((data) => {
                if (data.error != 1) {
                    // if (data.data.length > 0) {
                    // if (data.data[0].length > 0) {
                    var tempc1 = 0
                    var tempc2 = 0
                    data.data.length > 0 && data.data.map(item => {
                        if (item.Status == 'Returned') {
                            tempc2 = tempc2 + 1
                        } else {
                            tempc1 = tempc1 + 1
                        }
                    })
                    this.setState({ DDreturnListArr: data.data, mainList: data.data, PTRcount: tempc1, Rcount: tempc2 })
                    // }
                    // }
                    this.setState({ isLoading: false })
                } else {
                    toastError('Something went wrong...')
                    this.setState({ isLoading: false })

                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    renderList(currentRecords) {
        const { isLoading, DDreturnListArr, hallList, zoneList, currentPage, HallId, ZoneId, ExhRegistrationNo, CompanyName, vendorName, DDno, DDdate } = this.state
        return (
            <>
                <table class="table sticky-table text-nowrap table-bordered border-bottom border-2 mb-1 me-2">
                    <thead class="table-light">
                        <tr>
                            <th class="text-center">DD No.</th>
                            <th class="text-center">DD Date</th>
                            <th class="text-center">Hall</th>
                            <th class="text-center">Zone</th>
                            <th class="text-center">Stall</th>
                            <th>Exhibitor</th>
                            <th>Service Partner</th>
                            <th class="text-center">Status</th>
                            <th class="text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentRecords.length > 0 ? currentRecords.map(item => (
                            <tr>
                                <td class="text-center fw-semibold">{item['DD_Number']}</td>
                                <td class="text-center">{item['DD_Date'] != null && item['DD_Date'] != '' ? moment(item['DD_Date']).format("DD MMM YYYY") : ''}</td>
                                <td class="text-center hall-td">{item['Hall']}</td>
                                <td class="text-center">{item['Zone']}</td>
                                <td class="text-center">{item['Stall']}</td>
                                <td><span style={{ fontWeight: '600' }}>{item['Exhibitor']}</span> <br />{item['ExhibitorCompanyName']}</td>
                                <td class="vendor p-1">
                                    <div style={{ fontSize: '12px' }}>
                                        <div>
                                            <i class="fa fa-building-o grid-icon"></i>
                                            <span>{item['VendorCompanyName']}</span></div>

                                        <span class="mt-1" className="vendor-info-text">
                                            <i class="fa fa-user grid-icon"></i>
                                            {item['VendorName']} </span><br />
                                        <span class="mt-1" className="vendor-info-text">
                                            <i class="fa fa-phone grid-icon"></i>
                                            {item['VendorMobile']} </span><br />
                                        <span className="vendor-info-text">
                                            <i class="fa fa-envelope grid-icon"></i>
                                            {item['VendorEmail']}</span><br />
                                    </div>
                                </td>
                                <td class="text-center"><span class={item['Status'] == 'Returned' ? 'status text-aqua fw-normal' : 'status text-aqua fw-normal'}>{item['Status']}</span></td>
                                <td class="text-center">
                                    {/* <a href="dd-return-entry"> */}
                                    <i style={{ cursor: 'pointer' }} class="bi bi-eye grid-icon" onClick={() => this.handleUpdate(item['ExhStallPossessionVendorDDdetailsID'], item['Status'])}></i>
                                    {/* </a> */}
                                </td>
                            </tr>
                        )) : <tr>
                            <td colSpan={12} className="text-center">Record not found</td>
                        </tr>}
                    </tbody>
                </table >
            </>
        )
    }

    renderDamageList(currentRecords) {
        const { isLoading, DDreturnListArr, hallList, zoneList, currentPage, HallId, ZoneId, ExhRegistrationNo, CompanyName, vendorName, DDno, DDdate } = this.state
        return (
            <>
                <table class="table table-bordered table-striped">
                    <thead class="table-light">
                        <tr>
                            <th>Exhibitor Details</th>
                            <th >Contractor/ Service Partner Details</th>
                            <th class="text-center">Damage Marked By</th>
                            <th class="text-center">Damage From</th>
                            <th class="text-center">Damage Date</th>
                            <th style={{ width: '75px' }} class="text-center">View</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentRecords.length > 0 ? currentRecords.map(item => (
                            <tr>
                                <td><span style={{ fontWeight: "600" }}>{item['ExhRegistrationNo'] != '' ? item['ExhRegistrationNo'] : ''}</span> {item['ExhRegistrationNo'] != null && item['ExhRegistrationNo'] != '' ? <br /> : ''}{item['ExhibitorName']}</td>
                                <td class="vendor p-1 ">
                                    {<div style={{ lineHeight: '14px' }}>
                                        {item['CompanyName'] != null && item['CompanyName'] != '' && <span class="my-1 mt-0  ha-view-com fw-bold"><i class="fa fa-solid text-dark fa-building"></i>&nbsp;
                                            {item.CompanyName} </span>}
                                        <br />
                                        {item['PersonName'] != null && item['PersonName'] != '' && <span class="mt-0  ha-view-com" style={{ fontSize: "11px" }}><i class="fa fa-solid fa-user text-primary"></i>&nbsp; {item['PersonName']} </span>}
                                        <br />
                                        {item['MobileNo'] != null && item['MobileNo'] != '' && <span class="mt-1" style={{ fontSize: "11px" }}> <i class="fa fa-solid fa-phone text-danger"></i>
                                            &nbsp; {item['MobileNo']}  </span>}
                                        <br />
                                        {item['PrimaryEmail'] != null && item['PrimaryEmail'] != '' && <span style={{ fontSize: "11px" }}> <i class="fa fa-solid text-cyan fa-envelope"></i>
                                            &nbsp; {item['PrimaryEmail']} </span>}
                                        <br />
                                    </div>}
                                </td>
                                <td class="text-center ">{item.DamageMarkedBy}</td>
                                <td class="text-center ">{item.DamageFrom}</td>
                                <td class="text-center ">{moment(item.DamageDate).format('DD/MM/YYYY')}</td>
                                <td class="text-center">
                                    {/* <a href="dd-return-entry"> */}
                                    <i style={{ cursor: 'pointer' }} class="bi bi-eye grid-icon" onClick={() => this.getDamageDetails(item['ExhRegistrationID'], item['VendorID'], item.ExhRegistrationNo, item.ExhibitorName, item.DamageMarkedBy, item.DamageDate)}></i>
                                    {/* </a> */}
                                </td>
                            </tr>
                        )) : <tr>
                            <td colSpan={12} className="text-center">Record not found</td>
                        </tr>}
                    </tbody>
                </table >
            </>
        )
    }

    // Update Current Page
    updateItem(item) {
        const { accountEntryPassList } = this.state
        this.setState({ currentPage: item });
    }
    clearValue() {
        this.setState({
            DDno: '',
            DDdate: '',
            HallId: '',
            ZoneId: '',
            ExhRegistrationNo: '',
            CompanyName: '',
            vendorName: '',
        })
        setTimeout(() => {
            this.getDDreturnListArr()
        }, 100);
    }

    handleUpdate(id, status) {
        this.props.navigate('/ddReturnUpdate', { state: { ExhStallPossessionVendorDDdetailsID: id, status: status == 'Returned' ? 1 : 0 } })
    }

    onFilterClick(mode) {
        const { isLoading, ExitNo, HallId, ZoneId, isOpen, mainList, QrCodeImg, ExhRegistrationNo, ContractorCompanyName, CompanyName, hallList, zoneList, accountExitPassList, currentPage, dismantlePop, tcomp, tpending } = this.state
        console.log("pppp")
        var templist
        if (mode == 0) {
            templist = mainList.filter(item => item.Status == 'Returned')
        } else {
            templist = mainList.filter(item => item.Status != 'Returned')
        }
        this.setState({ DDreturnListArr: templist, damagetoggle: false })
    }

    getDamageDetails(exhid, venid, no, name, DamageMarkedBy, DamageDate) {
        const { isLoading, DDreturnListArr, hallList, zoneList, currentPage, HallId, ZoneId, ExhRegistrationNo, CompanyName, vendorName, DDno, DDdate } = this.state
        this.setState({ isLoading: true })
        this.props.getDamageDetails_action('', 3, exhid, venid)
            .then((data) => {
                if (data.error != 1) {
                    // this.setState({ damageList: data.data[0] })
                    var list = data.data[0]
                    var docList = []
                    for (var i = 0; i < list.length; i++) {
                        docList.push(`${DOC_BASE_URL + list[i].DocumentPath}`)
                    }
                    this.setState({
                        isLoading: false, damagePop: true, exhNo: no, exhname: name, damageRemark: data.data[0][0].Remark, imgarr: docList, damageMarked: DamageMarkedBy,
                        DamageDate: DamageDate
                    })
                } else {
                    toastError('Something went wrong...')
                    this.setState({ isLoading: false })

                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    getDamageList() {
        const { isLoading, DDreturnListArr, hallList, zoneList, currentPage, HallId, ZoneId, ExhRegistrationNo, CompanyName, vendorName, DDno, DDdate } = this.state
        // this.setState({ isLoading: true })
        this.props.getDamageList_action(ExhRegistrationNo, CompanyName, vendorName)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ damageList: data.data[0] })
                    this.setState({ isLoading: false })
                } else {
                    toastError('Something went wrong...')
                    this.setState({ isLoading: false })

                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    render() {
        const { isLoading, isOpen, DDreturnListArr, damageList, damagetoggle, hallList, zoneList, currentPage, HallId, ZoneId, ExhRegistrationNo, CompanyName, vendorName, DDno, DDdate, damagePop, exhNo, exhname, damageRemark, damageMarked, DamageDate, imgarr } = this.state
        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = damagetoggle ? damageList.slice(indexOfFirstRecord, indexOfLastRecord) : DDreturnListArr.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = damagetoggle ? Math.ceil(damageList.length / recordsPerPage) : Math.ceil(DDreturnListArr.length / recordsPerPage)
        return (
            <>

                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <HeaderWithLogo />
                {/* <HeaderWithLogo /> */}
                <>
                    <AdminDrawer />
                    {/* <div className="app-content with-dr-container com-height"> */}

                    <div className="with-dr-container">
                        <div className="main-container">

                            <div className="row m-0">
                                <div className="breadcrumb-scroll-fixed">
                                    <h6 className="mb-0 p-2 text-white">DD Return</h6>
                                </div>
                            </div>

                            <div className="admin-top-space pt-0 p-2 pb-0">
                                <div className="row m-0">
                                    <div className="col-xl-2">
                                        <label className="col-form-label">DD No.</label>
                                        <input type="text" className="form-control form-control-sm w-100"
                                            value={DDno}
                                            onChange={(e) => this.setState({ DDno: e.target.value })} />
                                    </div>
                                    <div className="col-xl-2">
                                        <label className="col-form-label">DD Date</label>
                                        <DatePicker className="form-control"
                                            dateFormat="dd-MM-yyyy"
                                            selected={DDdate ? new Date(DDdate) : ''}
                                            onChange={(e) => this.setState({ DDdate: e })}
                                            peekNextMonth
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            placeholderText="dd-mm-yyyy"
                                        />
                                    </div>

                                    <div className="col-xl-2">
                                        <label className="col-form-label">Hall</label>
                                        <select
                                            className="form-control"
                                            value={HallId}
                                            onChange={(e) => this.setState({ HallId: e.target.value })}
                                        >
                                            <option value="">Select</option>
                                            {hallList.map(data => (
                                                <option key={data.HallId} value={data.HallId}>{data.HallName}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="col-xl-2">
                                        <label className="col-form-label">Zone</label>
                                        <select
                                            className="form-control"
                                            value={ZoneId}
                                            onChange={(e) => this.setState({ ZoneId: e.target.value })}
                                        >
                                            <option value="">Select</option>
                                            {zoneList.map(data => (
                                                <option key={data.ZoneID} value={data.ZoneID}>{data.Zone}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="col-xl-2">
                                        <label className="col-form-label">Exhibitor Reg. No.</label>
                                        <input type="text" className="form-control form-control-sm w-100"
                                            value={ExhRegistrationNo}
                                            onChange={(e) => this.setState({ ExhRegistrationNo: e.target.value })} />
                                    </div>

                                    <div className="col-xl-2">
                                        <label className="col-form-label">Exhibitor</label>
                                        <input type="text" className="form-control form-control-sm w-100"
                                            value={CompanyName}
                                            onChange={(e) => this.setState({ CompanyName: e.target.value })} />
                                    </div>

                                    <div className="col-xl-2">
                                        <label className="col-form-label">Service Partner</label>
                                        <input type="text" className="form-control form-control-sm w-100"
                                            value={vendorName}
                                            onChange={(e) => this.setState({ vendorName: e.target.value })} />
                                    </div>
                                    <div className="col-xl-2 text-left mt-2">
                                        <label></label>

                                        <div
                                            className="d-flex gap-2 mt-3"
                                            role="group"
                                            aria-label="Basic example"
                                            style={{ float: "left" }}
                                        >
                                            <button
                                                type="button"
                                                className="btn btn-aqua"
                                                onClick={() => this.getDDreturnListArr()}
                                            >
                                                Search
                                            </button>

                                            <button
                                                type="button"
                                                className="btn btn-gray"
                                                onClick={() => this.clearValue()}
                                            >
                                                Clear
                                            </button>
                                        </div>
                                    </div>


                                </div>
                            </div>

                            <div className="row m-0 mx-2">
                            <div class="d-block d-md-flex justify-content-end align-items-center w-100 mb-1">
                                <div class="d-block d-md-flex align-items-center gap-1">
                                    <div class="p-1 rounded-1 status-btn mb-2"
                                        //  onClick={() => window.open(`${link_BASE_URL}damageList`, "_blank", "noopener,noreferrer")} 
                                        onClick={() => this.setState({ damagetoggle: !damagetoggle, currentPage: 1 })}
                                        style={{ cursor: 'pointer' }}>
                                        <i class="bi bi-exclamation-triangle-fill me-1 fs-6"></i>
                                        <span class="status-name">{!damagetoggle ? 'Damaged Record' : 'DD return list'}</span>
                                        {/* <strong class="ms-1 text-warning status-name">{this.state.PTRcount}</strong> */}
                                    </div>

                                    <div class="p-1 rounded-1 status-btn mb-2" onClick={() => this.onFilterClick(1)} style={{ cursor: 'pointer' }}>
                                        <i class="bi bi-hourglass-split me-1 fs-6"></i>
                                        <span class="status-name">Pending to Return:</span>
                                        <strong class="ms-1 status-name">{this.state.PTRcount}</strong>
                                    </div>

                                    <div class="p-1 rounded-1 status-btn mb-2" onClick={() => this.onFilterClick(0)} style={{ cursor: 'pointer' }}>
                                        <i class="bi bi-check-circle-fill fs-6 me-1"></i>
                                        <span class="status-name">Returned:</span>
                                        <strong class="ms-1 status-name">{this.state.Rcount}</strong>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div className="row m-2 mt-0 mx-3">
                                <div class="table-responsive sticky-table-wrapper service-list-grid p-0">
                                    {damagetoggle ? this.renderDamageList(currentRecords) : this.renderList(currentRecords)}
                                </div>
                                <div class="mt-2 float-left trp p-0">
                                <div class="table-record-pages">
                                    Page{currentPage}of{nPages}
                                </div>
                                {
                                    DDreturnListArr.length > 0 ?
                                        <Pagination
                                            nPages={nPages}
                                            currentPage={currentPage}
                                            setCurrentPage={this.updateItem}
                                        /> : <></>
                                }
                            </div>
                            </div>
                            

                        </div>
                    </div>


                </>
                <Modal
                    isOpen={this.state.damagePop} onRequestClose={() => this.setState({ damagePop: false })}
                >
                    {/* <div className="modal-dialog">
                                                          <div className="modal-content confirm-logout">
                                                              <div class="modal-header p-2">
                                                                  <h5 class="modal-title">Additional Furniture</h5>
                                                                  <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isOpen: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                                                              </div>
                                                              <div>
                                                              </div>
                                  
                                                          </div>
                                                      </div> */}

                    {/* <div className="modal-dialog modal-xl modal-dialog-centered" style={{ marginLeft: '325px', marginTop: '60px' }}> */}

                    <div class="modal-dialog modal-xl modal-dialog-centered" style={{ fontSize: 'larger' }}>
                        <div className="modal-content shadow-lg border-0 rounded-4">
                            <div class="modal-header bg-danger text-white py-2">
                                <h5 class="modal-title" style={{ fontSize: "16px" }}>Damaged Record</h5>
                                <button type="button" class="btn-close btn-close-white text-white" onClick={() => this.setState({ damagePop: false })} ></button>
                            </div>
                            <div class="modal-body">
                                <div >
                                    <strong style={{ fontSize: 'x-large' }}>{this.state.exhNo}</strong><br />
                                    <strong>{this.state.exhname}</strong><br /><br />
                                </div>
                                <div>
                                    Damage Marked By: <strong>{this.state.damageMarked}</strong><br />
                                    Damage Marked Date: <strong>{moment(this.state.DamageDate).format('DD/MM/YYYY')}</strong><br /><br />
                                </div>
                                <div>
                                    Remark: <strong>{this.state.damageRemark}</strong><br />
                                </div>
                                <div>
                                    Images<br />
                                    {imgarr.length > 0 && imgarr.map(item => (
                                        <img
                                            onClick={() => window.open(item, "_blank", "noopener,noreferrer")}
                                            src={item}
                                            style={{ margin: '2px', cursor: 'pointer' }}
                                            alt="Preview"
                                            width="200"
                                            height="200"
                                        />
                                    ))}
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-gray bg-secondary" onClick={() => this.setState({ damagePop: false })}>Cancel</button>
                            </div>
                        </div>
                    </div>
                </Modal>
            </>
        )
    }
}
export default withRouter(connect(null, {
    fill_action, getDamageList_action, getDamageDetails_action,
    getDDReturnList_action
})(DDReturnList));